import React from 'react';
import { Box, Typography, Button, CircularProgress, styled, Slide, Zoom } from '@mui/material';
import { CheckCircle, Email } from '@mui/icons-material';

interface SuccessStepProps {
  isLoading: boolean;
  onFinish: () => void;
}

const SuccessIcon = styled(CheckCircle)(({ theme }) => ({
  fontSize: 80,
  color: theme.palette.success.main,
  marginBottom: theme.spacing(2),
}));

const SuccessContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 350,
  textAlign: 'center',
  padding: theme.spacing(4),
}));

const SuccessStep: React.FC<SuccessStepProps> = ({ isLoading, onFinish }) => {
  return (
    <Slide direction="up" in={true} mountOnEnter unmountOnExit>
      <SuccessContainer>
        {isLoading ? (
          <CircularProgress size={60} thickness={4} />
        ) : (
          <>
            <Zoom in={true} style={{ transitionDelay: '300ms' }}>
              <SuccessIcon />
            </Zoom>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mt: 2 }}>
              Đăng ký thành công!
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, mb: 2 }}>
              Cảm ơn bạn đã đăng ký làm đối tác. Chúng tôi sẽ xem xét thông tin của bạn
              và liên hệ lại trong thời gian sớm nhất.
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              bgcolor: 'info.light', 
              p: 2, 
              borderRadius: 2,
              mb: 3
            }}>
              <Email color="info" sx={{ mr: 1 }} />
              <Typography variant="body2" color="info.dark">
                Chúng tôi đã gửi email xác nhận đến địa chỉ email của bạn.
              </Typography>
            </Box>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={onFinish}
              sx={{ 
                minWidth: 200,
                py: 1.5, 
                borderRadius: 2,
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)',
                }
              }}
            >
              Về trang chủ
            </Button>
          </>
        )}
      </SuccessContainer>
    </Slide>
  );
};

export default SuccessStep; 